<template>

  <marque-form
    v-if="marqueFormData"
    :title="title"
    :submit-button-text="submitButtonText"
    :marque-form-data="marqueFormData"
    @submitMarqueForm="onSubmit($event)"
  />

</template>

<script>

import router from '@/router'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import MarqueForm from './MarqueForm.vue'

export default {
  components: {
    MarqueForm,
  },
  data() {
    return {
      title: 'Mise à jour de la marque',
      submitButtonText: 'Modifier',
      marqueFormData: null,
    }
  },
  mounted() {
    const marqueId = router.currentRoute.params.id
    store.dispatch('modeles/fetchMarqueById', marqueId)
      .then(response => {
        this.marqueFormData = response.data
      })
  },
  setup() {
    const marqueId = router.currentRoute.params.id

    const toast = useToast()

    const onSubmit = formMarqueValue => store.dispatch('modeles/updateMarque', { marqueId, formMarqueValue })
      .then(() => {
        router.push({ name: 'marques-list' })
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erreur lors de la mise à jour de la marque',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    return {
      onSubmit,
    }
  },
}
</script>
